import { RootState } from 'editor/src/store/index';

import { mobileDevices } from 'editor/src/component/useDetectDeviceType';

const isMobile = (state: RootState) => mobileDevices.has(state.app.customerDeviceType);

export default isMobile;
